import {LazyMotion as FramerLazyMotion} from 'motion/react';

const loadFeatures = async () => import('./features').then(mod => mod.features);

const LazyMotion: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <FramerLazyMotion features={loadFeatures} strict>
    {children}
  </FramerLazyMotion>
);

export default LazyMotion;
